import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    // The OAuth redirect lands on the page that asked for sign-in; return there once the session is set.
    const back = window.location.pathname || "/commons";
    if (!sid) {
      navigate(back, { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sid }),
        });
        if (res.ok) setUser(await res.json());
      } catch {
        /* fall through to the page, which will show the sign-in prompt */
      }
      window.history.replaceState(null, "", back);
      navigate(back, { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="flex min-h-screen items-center justify-center bg-[#030305]"
    >
      <span className="font-mono-spec text-[0.62rem] text-[#8E8E93]/70">Entering…</span>
    </div>
  );
}
